import React from "react";
import { Box } from "@mui/material";
import { W } from "./wizardTokens";

/** The AI's own "I wasn't sure about this" note, with the source text it was reading, and a confirm action. */
export default function FlagBanner({ note, quote, onClear }) {
  return (
    <Box sx={{ bgcolor: W.dangerBg, borderRadius: "8px", p: "12px 14px", display: "flex", flexDirection: "column", gap: "10px" }}>
      <Box sx={{ fontSize: "13px", fontWeight: 600, color: W.danger }}>{note || "The AI wasn't sure about this one."}</Box>
      <Box component="button" type="button" onClick={onClear}
        sx={{ alignSelf: "flex-start", display: "inline-flex", alignItems: "center", gap: "6px", font: "inherit", fontSize: "12px", fontWeight: 700, textTransform: "uppercase", letterSpacing: ".02em", border: `1px solid ${W.line}`, bgcolor: "#fff", color: W.ink, borderRadius: "6px", px: "10px", py: "5px", cursor: "pointer", "&:hover": { bgcolor: W.surface2 } }}>
        <Box component="svg" width={12} height={12} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5" /></Box>
        Looks right
      </Box>
      {quote && (
        <Box sx={{ bgcolor: "#fff", border: `1px solid ${W.line}`, borderRadius: "6px", p: "8px 10px", fontFamily: "var(--font-mono)", fontSize: "12px", color: W.ink2, whiteSpace: "pre-wrap" }}>
          “{quote}”
        </Box>
      )}
    </Box>
  );
}
